import { render } from "./SideMenuItem.vue?vue&type=template&id=10b9cdae&scoped=true"
import script from "./SideMenuItem.vue?vue&type=script&lang=js"
export * from "./SideMenuItem.vue?vue&type=script&lang=js"

import "./SideMenuItem.vue?vue&type=style&index=0&id=10b9cdae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b9cdae"]])

export default __exports__